export const SHOW_SUGGESTED_COACHES_NOTIFICATION = 'SHOW_SUGGESTED_COACHES_NOTIFICATION';
export const HIDE_SUGGESTED_COACHES_NOTIFICATION = 'HIDE_SUGGESTED_COACHES_NOTIFICATION';